import { BaseSnapshotModel } from "../BaseSnapshotModel";

export class ConditionManagementSnapshotModel extends BaseSnapshotModel {
  constructor() {
    super();
    this.Model = {
      modelFields: [
        "blood_sugar_real_time_support",
        "prefered_contact_method",
        "health_real_time_support",
        "heart_health_phone_calls",
        "heart_health_text_messages"
      ],

      requiredFields: ["blood_sugar_real_time_support"]
    };
  }
}
